<ng-template #loadingPanelRef>
  <div class="loading-panel with-layout">
    <div class="brand with-layout">
      <div *ngIf="!spinner" class="lds-ripple">
        <div></div>
      </div>
      <mat-spinner *ngIf="spinner" [diameter]="diameter" [mode]="mode" [strokeWidth]="strokeWidth"> </mat-spinner>
      <span>{{ text }}</span>
    </div>
    <div class="status-text"></div>
  </div>
</ng-template>
